import { useState, useEffect, useRef } from 'react';

const useRoundLoader = (roundId, loaderDuration = 3000) => {
    const [showLoader, setShowLoader] = useState(true);

    const triggerLoader = () => {
        setShowLoader(true);
        setTimeout(() => {
            setShowLoader(false);
        }, loaderDuration);
    };

    // Round change pe loader
    useEffect(() => {
        triggerLoader();
    }, [loaderDuration]);

    // Tab background se foreground aane par loader
    // useEffect(() => {
    //     const handleVisibilityChange = () => {
    //         if (document.visibilityState === 'visible') {
    //             triggerLoader();
    //         }
    //     };

    //     document.addEventListener('visibilitychange', handleVisibilityChange);
    //     return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
    // }, []);

    return showLoader;
};

export default useRoundLoader;